import { ChangeEvent, useState } from 'react';
import { toast } from 'react-toastify';

let frontendUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  frontendUrl = import.meta.env.VITE_FRONTEND_ENDPOINT;
} else {
  frontendUrl = window.config.frontendBaseUrl;
}

const useBulkTmsModalUpload = () => {
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const splittedFileNameAndExtension = e.target.files[0].name.split('.');

      if (
        ['xlsx', 'csv'].indexOf(
          splittedFileNameAndExtension[splittedFileNameAndExtension.length - 1]
        ) === -1
      ) {
        toast.error('Invalid file type selected, Please select .xlsx or .csv file');
      } else {
        setFile(e.target.files[0]);
      }
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  return {
    file,
    handleFileChange,
    handleRemoveFile
  };
};

export default useBulkTmsModalUpload;
